module.exports = __webpack_public_path__ + "img/J13310.ef27743e.png";